/**
 * Bundled state boundaries - Natural Earth 10m (public domain), India only,
 * simplified with shared edges so neighbouring states meet exactly. Served
 * from frontend/public/geo, so they draw with the network off.
 */

import { useQuery } from '@tanstack/react-query'
import { C } from '../design/tokens'

export interface GeoCollection {
  type: 'FeatureCollection'
  features: {
    type: 'Feature'
    properties: { name: string; label_lon?: number; label_lat?: number }
    geometry: { type: string; coordinates: unknown }
  }[]
}

/** An absolute URL: MapLibre fetches GeoJSON in a worker, where a bare path does not resolve. */
export const geoUrl = (file: string) => new URL(`${import.meta.env.BASE_URL}geo/${file}`, window.location.href).href

export function useGeo(file: string) {
  return useQuery<GeoCollection>({
    queryKey: ['geo', file],
    queryFn: async () => {
      const r = await fetch(geoUrl(file))
      if (!r.ok) throw new Error(`HTTP ${r.status}`)
      return (await r.json()) as GeoCollection
    },
    staleTime: Infinity,
  })
}

/** State names show at low zoom and fade out as the view closes in on the flood. */
export const stateLabelOpacity = (zoom: number) => Math.max(0, Math.min(1, (8.5 - zoom) / 1.5))

export const STATE_LINE = C.mapDistrict
export const HOME_STATE_LINE = C.mapBoundary
export const STATE_LABEL = C.textDim
